import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UI } from '@leverege/ui-redux';
import { SHOW_OVERLAYS_KEY } from "../../../Constants.js";
const TYPE = 'rsrc.gallery.RsrcSelectedDialog';
export default function useSelectedDialogContext(opts) {
  const {
    delegate,
    detail,
    editorVisible,
    onToggleEditor,
    paginator,
    reloadData,
    selection,
    onClose
  } = opts;
  const showOverlays = useSelector(state => {
    const show = UI.get(state, SHOW_OVERLAYS_KEY);
    return show == null ? true : show;
  });
  const matchContext = useMemo(() => {
    return {
      client: TYPE,
      objectType: delegate.relationship.objectType,
      path: delegate.relationship.path
    };
  }, [delegate.relationship]);
  const context = useMemo(() => {
    return {
      clientProps: {
        relationship: delegate.relationship,
        delegate,
        target: selection?.items,
        paginator,
        reloadData,
        detail,
        showOverlays,
        onClose
      }
    };
  }, [delegate, selection, paginator, reloadData, detail, showOverlays, onClose]);
  const toolbarCxt = useMemo(() => {
    return {
      ...context,
      onToggleEditor,
      editorVisible
    };
  }, [context, onToggleEditor, editorVisible]);
  return useMemo(() => {
    return {
      matchContext,
      toolbarCxt
    };
  }, [matchContext, toolbarCxt]);
}